import api from "../../../../BasicComponent/Service/api";
import { ROLE_URL } from "../../../Utils/constService";

export const fetchRole = (params = {}) => {
  return api.get(`${ROLE_URL}`, { params });
};

export const fetchRoleAll = (params = {}) => {
  return api.get(`${ROLE_URL}/un-paged`, { params });
};

export const postRole = (data) => {
  return api.post(ROLE_URL, data);
};

export const putRole = (data, roleId) => {
  return api.put(`${ROLE_URL}/${roleId}`, data);
};

export const deleteRole = (roleId) => {
  return api.delete(`${ROLE_URL}/${roleId}`);
};
